import React, { useCallback, useEffect } from "react";
import Socket from "socket";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
import flip from "assets/images/och/flip.png";
import useSound from "use-sound";

const OCHPrePlay = ({
  isActivePlayer,
  OtherPlayerTurn,
  ActivePlayerInfo,
  roomId,sounds,
}) => {  const [your_turn] = useSound(sounds?.your_turn);


  const flipButtonClickAction = () => {
    const data = {
      action: "update-status",
      roomId
    };
    Socket.sendMessage(data);
  };
  const handleFlipButtonClick = useCallback(
    _.debounce(() => flipButtonClickAction(), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );

  useEffect(()=>{
if(isActivePlayer){
  your_turn();
}

  },[isActivePlayer])


  return (
    <motion.div    variants={divVariants}
    initial="hidden"
    animate="visible"
    exit="exit"  className="och-rules">
      <motion.h2    variants={fadeVariants} className="title">Get Ready!</motion.h2>
      <motion.p  variants={fadeVariants}  className="sub-title">
        {isActivePlayer ? "You're first." : `You're ${OtherPlayerTurn}`}
      </motion.p>
      <motion.div  variants={staticBounceVariants} className="rule-box">
        <h3>Rules</h3>
        <ol>
          <li>
            You can play a card of the same suit or number as the active card,
            or any 8.
          </li>
          <li>
            You must draw if you can't play a card, and you must pass if the
            draw deck is empty.
          </li>
          </ol>
          {isActivePlayer ? (
            <p>Flip the active card using the button below when ready!</p>
          ) : (
            <p>
              The First player will flip the active card to start the game when
              ready!
            </p>
          )}
       
      </motion.div>
      {isActivePlayer ? (
        <motion.div variant={staticBounceVariants} className="flip-btn">
          <img
            src={flip}
            className="img-fluid"
            alt=""
            onClick={() => handleFlipButtonClick()}
          />
          <p className="flip">flip</p>
        </motion.div>
      ) : (
        <motion.div variants={staticBounceVariants} className="player-flex">
          <div>
            <img
              src={ActivePlayerInfo?.profile_image}
              className="img-fluid user"
              alt=""
            />
          </div>
          <div className="player-name">
            <p className="type">Ist player</p>
            <p className="name">{ActivePlayerInfo?.display_name}</p>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default OCHPrePlay;
